export enum IncludeType {
  Available = 'available',
  Discontinued = 'discontinued',
  Supported = 'supported',
}
